export default __webpack_public_path__ + "5d1e48e7177dc4aec80b5ae40f44f7a2.svg";